import { type FieldType } from '@databases/model/field';
import { type MutableValue, type Value, type ValueJSON } from '@databases/model/value';
import { format } from 'date-fns';
import * as Y from 'yjs';

import { ValueProperties } from '../y-entry';
import { FieldMapping } from '../y-field';

import { YStringValue } from './y-string-value';

export class YDateValue
  extends YStringValue<FieldType.Date>
  implements Value<FieldType.Date>, MutableValue<FieldType.Date>
{
  static fromJSON(json: ValueJSON<FieldType.Date, string>) {
    return new YDateValue(YStringValue.mapFromJSON(json));
  }
}

function replaceTodayWithCurrentDate(value: string) {
  if (value === 'today') {
    // call format to handle proper conversion/localization of current date
    return format(new Date(), 'yyyy-MM-dd');
  }

  return value;
}
export class YDateValueWithoutCurrent
  extends YStringValue<FieldType.Date>
  implements Value<FieldType.Date>, MutableValue<FieldType.Date>
{
  static fromJSON(json: ValueJSON<FieldType.Date, string>) {
    return new YDateValueWithoutCurrent(this.mapFromJSON(json));
  }

  get value(): string {
    return this.getString(ValueProperties.value, '');
  }

  set value(data: string) {
    this.set(ValueProperties.value, replaceTodayWithCurrentDate(data));
  }

  static mapFromJSON<T extends FieldType>(json: ValueJSON<T, string>) {
    return new Y.Map([
      [ValueProperties.type, FieldMapping[json.type]],
      [ValueProperties.value, replaceTodayWithCurrentDate(json.value)]
    ]);
  }
}
